module.exports = __webpack_public_path__ + "static/media/7-10.63228e33.mp3";